import client from '../../base-api';

const serviceURL = '/dashboard/coach';

const dashboardCoachService = {

    getUnitsDoneChart(filterData: any) {
        return client.get(`${serviceURL}/units-done-chart/${filterData?.coachingType}/${filterData?.year}`);
    },

    getDashboardData() {
        return client.get(`${serviceURL}`);
    },
}

export default dashboardCoachService;